import definitions from "./alpine-resorts.json";
import type { AlpineView } from "./alpine-scenery";

/** Authored display settings only. These envelopes never define route access. */
export type AlpineResort = {
  slug: string;
  pisteAreasUrl?: string;
  pisteAreaDifficulties?: string[];
  name: string;
  anchor: [number, number];
  sourceZoom: number;
  extent: [number, number, number, number];
  relief: { envelope: [number, number][]; floor: number; transition: number; strength: number; feather: number };
  views: AlpineView[];
};

const point = (value: number[]): [number, number] => [value[0], value[1]];
function resort(value: typeof definitions["espace-killy"] & { pisteAreasUrl?: string; pisteAreaDifficulties?: string[] }): AlpineResort {
  return {
    slug: value.slug,
    ...(value.pisteAreasUrl ? { pisteAreasUrl: value.pisteAreasUrl, pisteAreaDifficulties: value.pisteAreaDifficulties } : {}),
    name: value.name,
    sourceZoom: value.sourceZoom,
    anchor: point(value.anchor),
    extent: [value.extent[0], value.extent[1], value.extent[2], value.extent[3]],
    relief: { ...value.relief, envelope: value.relief.envelope.map(point) },
    views: value.views.map(view => ({ ...view, center: point(view.center) })),
  };
}
export const ALPINE_RESORTS: Record<string, AlpineResort> = Object.fromEntries(
  Object.entries(definitions).map(([slug, definition]) => [slug, resort(definition)]),
);

export function alpineResort(areaSlug: string | null, sport: string): AlpineResort | null {
  if (sport !== "ski" || !areaSlug || !Object.hasOwn(ALPINE_RESORTS, areaSlug)) return null;
  return ALPINE_RESORTS[areaSlug as keyof typeof ALPINE_RESORTS];
}

export function alpineSnowCorners(resort: AlpineResort): [[number, number], [number, number], [number, number], [number, number]] {
  const [left, top, right, bottom] = resort.extent, n = 2 ** resort.sourceZoom;
  const point = (x: number, y: number): [number, number] => [x / n * 360 - 180, Math.atan(Math.sinh(Math.PI * (1 - 2 * y / n))) * 180 / Math.PI];
  return [point(left, top), point(right + 1, top), point(right + 1, bottom + 1), point(left, bottom + 1)];
}
